import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import MyParties from "../../pages/MyParties";
import Header from "../Header";
import AlsoGoingOut from "./AlsoGoingOut";
import AuthClient from "../../api/AuthClient";
import { useNavigate } from "react-router";
import { routes } from "../../routes/routes";
import { useContext, useEffect, useState } from "react";
import { CurrentPathContext } from "../../GlobalContext/currentPathContext";
import GetAllCitiesApi from "../../api/GetAllCitiesApi";
import { parseCitiesResponse } from "../../api/parseResponse/parseAllCitiesResponse";
import { CitiesInfoContext } from "../../AllCitiesContext";

const authClient = new AuthClient();

const GuestModePages = () => {

  const { activeTab, setActiveTab } = useContext(CurrentPathContext);
  const { citiesInfo, setAllCitiesContextData } = useContext(CitiesInfoContext)
  const [partiesCount, setPartiesCount] = useState<number>();

  const isLoggedIn = authClient.isLoggedIn();
  const navigate = useNavigate();

  const SetMyPartiesCount = (partiesCount: number) => {
    setPartiesCount(partiesCount);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(routes.Login);
    }

    if (isLoggedIn && citiesInfo.length === 0) {
      try {
        const getAllCitiesApi = new GetAllCitiesApi(authClient);

        getAllCitiesApi.getAllCities().then((response) => {
          if (response.data.length > 0) {
            const parsedData = parseCitiesResponse(response.data);
            setAllCitiesContextData([parsedData]);
          }
        });
      } catch (error) {
        console.error("Error fetching cities", error);
      }
    }
  }, [isLoggedIn, navigate]);

  return (
    <>
      <Header />
      <div className="centerGroup">

        <div className="desktopUI">
          <Container className="p-0">
            <Tabs
              onSelect={(key) => setActiveTab(key as string)}
              defaultActiveKey={activeTab ? activeTab : "home"}
              id="fill-tab-example"
              className="mb-3"
              fill
            >
              <Tab eventKey="home" title={`My Parties (${partiesCount ?? 0})`}>
                {isLoggedIn && <MyParties SetMyPartiesCount={SetMyPartiesCount} />}
              </Tab>
              <Tab eventKey="alsoGoingOut" title="Also Going Out">
                {isLoggedIn && <AlsoGoingOut />}
              </Tab>
            </Tabs>
          </Container>
        </div>
      </div>
    </>
  );
};

export default GuestModePages;
